/**
 * md3cBrandConfig.js — md3c.com marketing chrome.
 * Shaped by: md3c step 4b; owner decisions R-1, R-3, R-4, R-6, R-ADDR, E-1, R-24.
 * Invariants: wordmark is "Fusion MSI Network" (with the space). Copyright year
 * is the fixed string 2026, never a computed year. Colors and fonts stay in
 * @asi/design-tokens via the shared theme. No new legal caption is authored here.
 * Related: fusionMsiBrandConfig.js, resolveMarketingBrandConfig.js,
 * public/brand/md3c/.
 */
import { FOOTER_DISCLOSURE } from 'features/decisionPoint/marketing/decisionPointMarketingData';

const BRAND_BASE = '/brand/md3c';

/**
 * The FusionMSI disclosure names the product (Fusion Medical SuperIntelligence /
 * FusionMSI). It does not name fusionmsi.com, a host-only page, or a host legal
 * entity, so it is reused as platform language. locationNote stays empty: that
 * sentence is about FusionMSI regional pages.
 */
export const MD3C_BRAND_CONFIG = {
  wordmark: 'Fusion MSI Network',
  tagline: 'Medical SuperIntelligence™ + Continuity of Care',
  byline: 'Brought to you by MD3C, LLC',
  homeHref: '/',
  navItems: [
    { label: 'Home', href: '/', external: false },
    { label: 'Critical Challenges', href: '/critical-challenges', external: false },
    { label: 'Blog', href: '/care-before-the-visit/', external: false },
    { label: 'About', href: '/about-us', external: false },
    { label: 'Fusion MSI Network ↗', href: 'https://fusionmsi.com', external: true },
  ],
  footer: {
    entityLine: 'Brought to you by MD3C, LLC',
    address: 'MD3C, LLC, Chicago, IL USA',
    copyright: '© 2026 MD3C, LLC',
    caption: FOOTER_DISCLOSURE,
    locationNote: '',
    links: [
      {
        label: 'Privacy Policy',
        href: 'https://fusionmsi.com/privacy-policy',
        external: true,
      },
      {
        label: 'Terms of Use',
        href: 'https://fusionmsi.com/terms-of-use',
        external: true,
      },
      { label: 'BAA', href: 'https://fusionmsi.com/baa', external: true },
    ],
  },
  favicon: {
    svg: `${BRAND_BASE}/favicon.svg`,
    png: `${BRAND_BASE}/favicon-64.png`,
    apple: `${BRAND_BASE}/app-icon-180.png`,
  },
  ogImage: `${BRAND_BASE}/og-image.png`,
  title: 'MD3C, LLC — Fusion MSI Network',
  /** Empty until the owner supplies the Zoho Campaigns hosted form URL (R-24). */
  zohoCampaignsSignupUrl: '',
};
